import { createEnv } from "@t3-oss/env-nextjs"
import { z } from "zod"

const booleanSchema = z
  .union([z.string(), z.number(), z.boolean()])
  // transform to boolean
  .transform((val) => {
    if (typeof val === "boolean") {
      return val
    }

    if (typeof val === "number") {
      if (val === 1) {
        return true
      }

      if (val === 0) {
        return false
      }
    }

    if (typeof val === "string") {
      if (val.toLowerCase() === "true") {
        return true
      }

      if (val.toLowerCase() === "false") {
        return false
      }
    }

    return z.NEVER
  })
  // check if it's a really boolean
  .pipe(z.boolean())

export const env = createEnv({
  server: {
    NODE_ENV: z.string(),
    DATABASE_URL: z.url(),
    LOG_LEVEL: z.enum(["debug", "info", "warn", "error", "fatal"]),
    REDIS_URL: z.url(),
    TMP_DIR: z.string().prefault("./tmp"),

    MAILGUN_API_KEY: z.string(),
    BASE_URL: z.string().nullish(),

    GOOGLE_CDN_URL: z.url(),
    GOOGLE_CLOUD_BUCKET_NAME: z.string(),
    GOOGLE_CLOUD_PROJECT_ID: z.string().prefault("leafy-acumen-218907"),
    GOOGLE_CLOUD_BASE64_CREDENTIALS: z.string(),

    DEVTOOLS_ENABLED: booleanSchema.default(false),
    TRPC_STREAMING_DISABLED: booleanSchema.default(false),
    AUTH_SECRET: z.string(),
  },
  client: {
    NEXT_PUBLIC_MIXPANEL_TOKEN: z.string().optional(),
    NEXT_PUBLIC_ENABLE_ANALYTICS_IN_DEV: z.string().optional().default('false'),
  },
})

export default env
